import { getGlobalClasses } from '../api/globalClassAPI';
import { getGlobalManufacturers } from '../api/globalManufacturerAPI';

const PAGE_SIZE = 8;

const normalizeText = (value) => String(value ?? '').trim().toLowerCase();

const extractOptions = (result) => {
  if (Array.isArray(result)) {
    return result;
  }

  if (!result || typeof result !== 'object') {
    return [];
  }

  if (Array.isArray(result.data)) {
    return result.data;
  }

  if (Array.isArray(result.results)) {
    return result.results;
  }

  return [];
};

const createClientPaginatedLoader = (fetchAll, mapItem) => {
  let cachePromise = null;

  const getAllItems = async () => {
    if (!cachePromise) {
      cachePromise = Promise.resolve(fetchAll()).then(extractOptions);
    }
    return cachePromise;
  };

  return async (inputValue = '', { page = 1 } = {}) => {
    const search = normalizeText(inputValue);
    const pageNumber = typeof page === 'number' && page > 0 ? page : 1;

    try {
      const allItems = await getAllItems();
      const filtered = search
        ? allItems.filter((item) => normalizeText(mapItem(item).label).includes(search))
        : allItems;

      const mapped = filtered
        .map(mapItem)
        .sort((a, b) => a.label.localeCompare(b.label));
      const startIndex = (pageNumber - 1) * PAGE_SIZE;
      const options = mapped.slice(startIndex, startIndex + PAGE_SIZE);

      return {
        options,
        hasMore: startIndex + PAGE_SIZE < mapped.length,
        totalCount: mapped.length,
        pageSize: PAGE_SIZE,
      };
    } catch (err) {
      console.error('Error fetching reference filter options:', err);
      cachePromise = null;
      return { options: [], hasMore: false };
    }
  };
};

export const loadGlobalClassFilterOptions = createClientPaginatedLoader(
  getGlobalClasses,
  (item) => ({
    value: item.id,
    label: item.className,
    raw: item,
  }),
);

export const loadGlobalManufacturerFilterOptions = createClientPaginatedLoader(
  getGlobalManufacturers,
  (item) => ({
    value: item.id,
    label: item.manufacturer,
    raw: item,
  }),
);
